import { Button } from 'primereact/button'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import importVanBangProcessor from '../../../processor/importVanBangProcessor'

const XacNhanChuyen = (props) => {
  const [visible, setVisible] = useState(false)

  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)

  const toggle = () => setVisible(!visible)

  const { datas, khoaThiId, onDone } = props
  const chuyenChinhThuc = async () => {
    document.getElementById('btn-lamlai').disabled = true
    document.getElementById('btn-xacnhan').disabled = true
    const rs = await importVanBangProcessor.chuyenChinhThuc(khoaThiId)
    document.getElementById('btn-lamlai').disabled = false
    document.getElementById('btn-xacnhan').disabled = false
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) {
      if (onDone) onDone()
    }
  }
  return (
    <>
      <div>
        <Button
          id="btn-xacnhan"
          disabled={datas.length === 0}
          icon="pi pi-reply"
          className="ml-2 mb-2"
          onClick={async () => {
            document.getElementById('btn-lamlai').disabled = true
            document.getElementById('btn-xacnhan').disabled = true
            const rs = await importVanBangProcessor.checKHaveInvalid(khoaThiId)
            document.getElementById('btn-lamlai').disabled = false
            document.getElementById('btn-xacnhan').disabled = false
            if (rs.isSuccess) {
              const count = parseInt(rs.data, 10)
              if (count > 0) {
                toast({ type: 'error', message: 'Tồn tại văn bằng không hợp lệ' })
                toggle()
              } else {
                confirm({
                  action: chuyenChinhThuc,
                  body: 'Bạn có chắc chắn muốn chuyển thành dữ liệu văn bằng chính thức',
                })
              }
            }
          }}
          label="Xác nhận"
        />
      </div>
    </>
  )
}
export default XacNhanChuyen
